module.exports = __webpack_public_path__ + "static/media/checkbox.47fc2795.svg";